/**
 * Translation Service for ConstructHelp chat messages.
 * Backed by the platform's GPT translator (POST /api/translator/text) — accurate
 * construction jargon across 12 languages. Target defaults to the user's
 * preferred language (profile settings); messages already in that language
 * are translated to English instead.
 */
import axiosInstance from '../api/api';

export const LANGUAGES = {
  en: { code: 'en', name: 'English', flag: '🇺🇸' },
  es: { code: 'es', name: 'Spanish', flag: '🇲🇽' },
  pt: { code: 'pt', name: 'Portuguese', flag: '🇧🇷' },
  fr: { code: 'fr', name: 'French', flag: '🇫🇷' },
  pl: { code: 'pl', name: 'Polish', flag: '🇵🇱' },
  ru: { code: 'ru', name: 'Russian', flag: '🇷🇺' },
  uk: { code: 'uk', name: 'Ukrainian', flag: '🇺🇦' },
  zh: { code: 'zh', name: 'Chinese (Mandarin)', flag: '🇨🇳' },
  vi: { code: 'vi', name: 'Vietnamese', flag: '🇻🇳' },
  ko: { code: 'ko', name: 'Korean', flag: '🇰🇷' },
  tl: { code: 'tl', name: 'Tagalog', flag: '🇵🇭' },
  ht: { code: 'ht', name: 'Haitian Creole', flag: '🇭🇹' },
};

export const autoTranslate = async (text, targetLang = null) => {
  if (!text || text.trim().length === 0) {
    return { success: false, error: 'No text to translate' };
  }
  try {
    const { data } = await axiosInstance.post('/translator/text', {
      text,
      target_lang: targetLang || undefined,
    });
    return {
      success: true,
      translatedText: data.translation,
      fromLang: data.detected_lang,
      toLang: data.target_lang,
    };
  } catch (err) {
    return {
      success: false,
      error: err.response?.data?.detail || 'Translation failed. Please try again.',
    };
  }
};

export const translateText = (text, from, to) => autoTranslate(text, to);

export default { LANGUAGES, autoTranslate, translateText };
